import { GET_STATIC_PAGE_CONTENT } from './constants';

export function loadStaticPageContent(name) {
  return (dispatch, getState) => {
    return dispatch({
      type: GET_STATIC_PAGE_CONTENT,
      name,
      request: {
        method: 'GET',
        requestRoot: '/',
        endpoint: `content/${name}.json`
      }
    });
  };
}



// WEBPACK FOOTER //
// ./src/redux/StaticPages/actions.js